import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import InvoicePaymentDataDisplay from '@/views/my-projects/components/invoice/paymentdata/InvoicePaymentDataDisplay.vue';
import { ref } from 'vue';
import InvoicePaymentDataEditor from '@/views/my-projects/components/invoice/paymentdata/InvoicePaymentDataEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePaymentData',
  setup(__props) {

const saveCallback = () => {
  console.log('Would save!');
};

const paymentData = ref({
  institute: 'Deutsche Kombinatsbank Rotherburg',
  iban: 'DE 12412341234 123412341234',
  bic: 'DEUTDEDB123',
  currency: 'CHF',
  vatId: 'DE523452345',
  vat: '19',
  reverseCharge: 'no'
});


return { __sfc: true,saveCallback, paymentData, InvoiceSection, InvoicePaymentDataDisplay, InvoicePaymentDataEditor }
}

})